<!-- 预约管理 -->
<template>
  <!-- 查询输入框开始 -->
  <a-form
      ref="formRef"
      name="advanced_search"
      class="ant-advanced-search-form mySerachForm"
      :model="formState"
      @finish="onFinish"
    >
      <a-row :gutter="24">
      
        <a-col  :span="8">
            <a-form-item  name="kcname" label="课程名称" >
              <a-input class="input" v-model:value="formState.kcname" placeholder="请输入课程名称"></a-input>
            </a-form-item>
          </a-col>
          <a-col  :span="8"><a-form-item name="class_date_begin"  label="上课日期开始" >
              <a-input  class="input"  v-model:value="formState.class_date_begin" placeholder="请输入上课开始日期"></a-input>
            </a-form-item>
          </a-col>
          <a-col  :span="8"><a-form-item name="class_date_end"  label="上课日期结束" >
              <a-input  class="input"  v-model:value="formState.class_date_end" placeholder="请输入上课结束日期"></a-input>
            </a-form-item>
          </a-col>
          <a-col  :span="8"><a-form-item name="unit_name"  label="单位名称" >
              <a-input  class="input"  v-model:value="formState.unit_name" placeholder="请输入单位名称"></a-input>
            </a-form-item>
          </a-col>
          <a-col  :span="8"><a-form-item name="status"  label="课程状态" >
            <a-select
                  v-model:value="formState.status"
                  placeholder="请选择课程状态"
                  style="width: 200px"
                  
                >
                  <!-- 课程状态选项 -->
                  <a-select-option value="">全部状态</a-select-option>
                  <a-select-option value="0">待安排老师</a-select-option>
                  <a-select-option value="1">待上课</a-select-option>
                  <a-select-option value="2">已上课</a-select-option>
                  <a-select-option value="3">已取消</a-select-option>
                </a-select>
            </a-form-item>

          </a-col>
          <a-col  :span="8"><a-form-item name="teacher_name"  label="授课老师" >
              <a-input  class="input"  v-model:value="formState.teacher_name" placeholder="请输入授课老师"></a-input>
            </a-form-item>
          </a-col>
          <a-col  :span="8"><a-form-item name="phone"  label="联系电话" >
              <a-input  class="input"  v-model:value="formState.phone" placeholder="请输入联系电话"></a-input>
            </a-form-item>
          </a-col>
      </a-row>
      <a-row>
        <a-col :span="24" style="text-align: right">
          <a-button type="primary" html-type="submit">查询</a-button>
          <a-button style="margin: 0 8px" @click="() => formRef.resetFields()">重置</a-button>
          
        </a-col>
      </a-row>
    </a-form>

  <!-- 查询输入框结束 -->

  <a-table :columns="columns" :data-source="data" size="small" :pagination="false"  bordered>
    <template #bodyCell="{ column, text, record }">
      <template v-if="['name', 'age'].includes(column.dataIndex)">
        <div>
          <a-input
            v-if="editableData[record.id]"
            v-model:value="editableData[record.id][column.dataIndex]"
            style="margin: -5px 0"
          />
          <template v-else>
            {{ text }}
          </template>
        </div>
      </template>
      <template v-else-if="column.dataIndex === 'operation'">
        <div class="editable-row-operations">
         
          <span>
             <a  @click="onEdit(record)">编辑</a>
             <a  @click="baomingList(record)">报名列表</a>
             <a  @click="dakaInage(record)">课程图片</a>
             <a  @click="chaifenkecheng(record)">拆分课程</a>
             <a v-if="isShowAddModel" @click="tuisong(record)">推送</a>
          </span>
        </div>
      </template>
    </template>
  </a-table>
  <a-pagination class="pagination" v-model:current="current" v-model:total="total"  v-model:pageSize="pageSize" :hideOnSinglePage="true" @change="onChange" @showSizeChange="showSizeChange" />
  
  <!-- 可编辑表格结束 -->


  <!-- 新增页面开始 -->
  <a-modal
      v-model:visible="visible"
      :title="saveFormState.id ?'编辑预约':'新增预约'"
      ok-text="提交"
    
      cancel-text="取消"
      @ok="updateYuyue"
      @cancel="afterClose"
    >
      <a-form ref="saveFormRef" :model="saveFormState"   layout="horizontal" name="user_form_in_modal">
       
        <a-form-item  label="课程名称" name="kcname" :rules="[{ required: true, message: '请输入课程名称' }]">
          <a-input  readonly v-model:value="saveFormState.kcname" />
        </a-form-item>

        <a-form-item label="上课日期" name="class_date" :rules="[{ required: true, message: '请输入上课日期' }]">
          
          <a-date-picker v-model:value="saveFormState.class_date" />
        </a-form-item>
        
        <a-form-item  label="开始时间"  name="begin_time" :rules="[{ required: true, message: '请输入结束时间' }]">
           <a-time-picker   v-model:value="saveFormState.begin_time" placeholder="选择开始时间"  format="HH:mm:ss" :minute-step="5"  />
         </a-form-item>
        <a-form-item label="结束时间" name="end_time" :rules="[{ required: true, message: '请输入结束时间' }]">
          <a-time-picker   v-model:value="saveFormState.end_time" placeholder="选择开始时间"  format="HH:mm:ss" :minute-step="5"  />
        </a-form-item>
        
        <a-form-item label="人数" name="people_size" :rules="[{ required:true, message: '请输入人数' }]">
          <a-input v-model:value="saveFormState.people_size" />
        </a-form-item>
        <a-form-item label="预约联系人" name="name" :rules="[{ required:true, message: '请输入预约联系人' }]">
          <a-input v-model:value="saveFormState.name" />
        </a-form-item>
        <a-form-item label="联系人电话" name="phone" :rules="[{ required:true, message: '请输入联系人电话' }]">
          <a-input v-model:value="saveFormState.phone" />
        </a-form-item>
        <a-form-item label="单位名称" name="unit_name" >
          <a-input  readonly v-model:value="saveFormState.unit_name" />
        </a-form-item>
        <a-form-item label="机构名称" name="team_id" :rules="[{ required:true, message: '请输入机构名称' }]">
          <a-select v-model:value="saveFormState.team_id" @change="handleChangeTeam">
		        <a-select-option v-for="item in teamNameList" :value="item.team_id" :key="item.team_id" :label="item.team_name">
			        {{ item.team_name }}
		        </a-select-option>
	        </a-select>
        </a-form-item>
        <a-form-item label="授课老师" name="teacher_id" :rules="[{ required:true, message: '请输入授课老师' }]">
          <a-select v-model:value="saveFormState.teacher_id" @change="handleChange">
		        <a-select-option v-for="item in teacherNameList" :value="item.teacher_id" :key="item.teacher_id" :label="item.teacher_name">
			        {{ item.teacher_name }}
		        </a-select-option>
	        </a-select>
        </a-form-item>
        <a-form-item label="课程状态" name="status" :rules="[{ required:true, message: '请输入课程状态' }]">
          
          <a-select v-model:value="saveFormState.status" @change="handleChangeStatus2">
                  <a-select-option value="0">待安排老师</a-select-option>
                  <a-select-option value="1">待上课</a-select-option>
                  <a-select-option value="2">已上课</a-select-option>
                  <a-select-option value="3">已取消</a-select-option>
	        </a-select>

        </a-form-item>
        <a-form-item label="上课地址" name="address" :rules="[{ required:true, message: '请输入上课地址' }]">
          <a-input v-model:value="saveFormState.address" />
        </a-form-item>
        <a-form-item label="修改说明" name="memo" :rules="[{ required:true, message: '请输入修改说明' }]">
          <a-input v-model:value="saveFormState.memo" />
        </a-form-item>
      </a-form>
    </a-modal>

  <!-- 新增页面结束 -->

<!-- 图片弹窗层 -->
<a-modal
      v-model:visible="imagesVisible"
      title="课程图片列表"
      cancel-text="关闭"
      :footer="null"  
      :width="1200"
      @cancel="handleCancel"
    >

    <a-upload
                v-model:fileList="saveExcelFormState.upload"
                :custom-request="customUploadRequest"
                
                list-type="picture"
              >
                <a-button>
                  <template #icon><UploadOutlined /></template>
                  上传图片
                </a-button>
              </a-upload>
    <div style="margin-top: 16px;" class="image-display-demo">
    
      <a-descriptions  column="1">
        <!-- 5. 图片列表（带预览） -->
        <a-descriptions-item label="">
          <div  class="image-container">

          <div  v-for="(img, index) in imagesData" :key="index" class="image-item" >
              <a-image
                :key="index"
                :src="img.imgurl"
                alt=""
                preview
                style="width: 240px; height: 200px; margin-right: 8px"
              />
              <a-icon
                class="delete-icon"
                type="delete"
                theme="filled"
                @click.stop="handleDelete(index, img.id)"  
                title="删除图片"
              />
            </div>
          </div>
         
        </a-descriptions-item>
      </a-descriptions>
   
  </div>
   
    </a-modal>


    <!-- 详情列表弹窗 -->
    <a-modal
      v-model:visible="detailVisible"
      title="报名列表"
      cancel-text="关闭"
      :footer="null"  
      :width="1200"
      @cancel="handleCancel"
    >

      
    <a-form ref="saveFormRef2" :model="saveFormState2"   layout="horizontal" name="user_form_in_modal2">
      <a-row :gutter="24">
      
      <a-col  :span="8">
       <a-form-item  label="课程名称" name="kcname" >
         <a-input  readonly v-model:value="saveFormState2.kcname" />
       </a-form-item>
</a-col>
<a-col  :span="8">   <a-form-item label="上课日期" name="class_date" >
        <a-input readonly v-model:value="saveFormState2.class_date" />
         
       </a-form-item>
      </a-col>   
       <a-col  :span="8">     <a-form-item  label="开始时间"  name="begin_time" >
        <a-input readonly v-model:value="saveFormState2.begin_time" />
        </a-form-item></a-col>
        <a-col  :span="8">      <a-form-item label="结束时间" name="end_time" >
        <a-input readonly v-model:value="saveFormState2.end_time" />
       </a-form-item></a-col>
      
       <a-col  :span="8">      <a-form-item label="预约联系人" name="name">
         <a-input readonly v-model:value="saveFormState2.name" />
       </a-form-item></a-col>
       
       <a-col  :span="8">     <a-form-item label="单位名称" name="unit_name" >
         <a-input  readonly v-model:value="saveFormState2.unit_name" />
       </a-form-item></a-col>
       <a-col  :span="8">     <a-form-item label="授课老师" name="teacher_name" >
        <a-input readonly v-model:value="saveFormState2.teacher_name" />
       </a-form-item></a-col>
      
       <a-col  :span="8">     <a-form-item label="上课地址" name="address">
         <a-input readonly v-model:value="saveFormState2.address" />
       </a-form-item></a-col>
       
       </a-row>

       <a-row>

        <a-upload
                v-model:fileList="saveExcelFormState.upload" 
                :custom-request="customUploadExcelRequest"
                multiple  
               :file-list="saveExcelFormState.upload"  
              >
                <a-button>
                  <template #icon><UploadOutlined /></template>
                  上传文件
                </a-button>
              </a-upload>
             

                <!-- 下载静态文件按钮 -->
                <a-button 
                  @click="downloadStaticFile"
                  :loading="downloading"
                >
                <template #icon><ArrowDownOutlined /></template>
                下载模版
                </a-button>
      </a-row>
</a-form>

      <a-table
        :columns="detailColumns"
        :data-source="currentDetailData"
        row-key="id"
        bordered
        :pagination="false"
      />
    </a-modal>



</template>
<script setup>
import { cloneDeep } from 'lodash-es';
import axios from  'axios'
import {message} from 'ant-design-vue'
import {reactive, ref,toRefs,onMounted } from 'vue'
import { UploadOutlined,ArrowDownOutlined } from '@ant-design/icons-vue';
import {baseUrl} from '../utils/const.js'
import moment from 'moment'; // 需要引入 moment 库
import { $fetchReservationList,$getBaomingList,$updateYuyue,$getDakaImageList,$tuisong,$addUploadImage,$deleteUploadImage,$chaifenkecheng } from '../api/reservation.js';
import { $fetchTeacherOptions ,$fetchTeamOptions} from '../api/course.js';
import { $uploadCert } from '../api/systemTeacher.js';
//清空表单时可以用的上，其他的没什么用
const good_at_list=JSON.parse(localStorage.getItem("good_at_list"));
// 选项列表

const area_list=JSON.parse(localStorage.getItem("area_list"));
const saveExcelFormState=reactive({
  upload:[],
})
const saveFormState=reactive({
  id:'',//id,
  kcid:"",
  kcname:'',//kcname,//课程名称
  class_date:'',//class_date,//上课时间
  begin_time:'',//begin_time,//开始时间
  end_time:'',//end_time,//结束时间
  people_size:'',//people_size,//人数
  name:'',//name,//预约联系人
  phone:'',//phone,//联系人电话
  unit_name:'',//unit_name,//单位名称
  teacher_id:'',
  teacher_name:'',//teacher_name,//授课老师
  status:'',//status,//课程状态
  address:'',//address,//上课地址
  memo:'',//memo,//修改备注
  team_id:'',
  team_name:'',
})
const saveFormState2=reactive({
  id:'',//id,
  kcid:"",
  kcname:'',//kcname,//课程名称
  class_date:'',//class_date,//上课时间
  begin_time:'',//begin_time,//开始时间
  end_time:'',//end_time,//结束时间
  people_size:'',//people_size,//人数
  name:'',//name,//预约联系人
  phone:'',//phone,//联系人电话
  unit_name:'',//unit_name,//单位名称
  teacher_id:'',
  teacher_name:'',//teacher_name,//授课老师
  status:'',//status,//课程状态
  address:'',//address,//上课地址
  memo:'',//memo,//修改备注
  team_id:'',
  team_name:'',
})
console.log(good_at_list)
const teacherNameList = ref([]);
const teamNameList = ref([]);
const handleChange = (value, option) => {
  const selectedKey = option.key; // 或者使用 option.value 获取 key
  const selectedText = option.label; // 获取文本
  console.log("selectedKey="+selectedKey)
  console.log("selectedText="+selectedText)
  saveFormState.teacher_id=selectedKey
  saveFormState.teacher_name=selectedText
}


const childDataCache = ref({});
const handleChangeTeam = async (value,option) =>{
  const selectedKey = option.key; // 或者使用 option.value 获取 key
  const selectedText = option.label; // 获取文本
  console.log("selectedKey="+selectedKey)
  console.log("selectedText="+selectedText)
  saveFormState.team_id=selectedKey
  saveFormState.team_name=selectedText;

  //子级的值，置空
  saveFormState.teacher_id='';
  saveFormState.teacher_name='';
  if(selectedKey==''|| selectedKey==null|| selectedKey=="null"){//不选择的时候
    teacherNameList.value =[]
    return;
  }
  // 先检查缓存
  if(childDataCache.value[selectedKey]) {
    teacherNameList.value = childDataCache.value[selectedKey];
    return;
  }
  //缓存没有，在查询接口
  if(selectedKey==''|| selectedKey==null|| selectedKey=="null"){//不选择的时候

  }else{
    fetchTeacherOptions();
  }
  

}
//上传文件
const shangchuanBaoming = info => {
  if (info.file.status !== 'uploading') {
    console.log(info.file, info.fileList);
  }
  if (info.file.status === 'done') {
    message.success(`${info.file.name} file uploaded successfully`);
  } else if (info.file.status === 'error') {
    message.error(`${info.file.name} file upload failed.`);
  }
};
const fileList = ref([]);
const headers = {
  authorization: 'authorization-text',
};

const handleChangeStatus2=(value, option) => {
  const selectedKey = option.key; 
  console.log("value="+value)
  console.log("selectedKey="+selectedKey)

  saveFormState.status=value

}

const downloadTempload=async()=>{ 
  window.location.href = './temp.xlsx';

}

const downloading = ref(false);

/**
 * 下载项目public目录下的静态文件
 */
const downloadStaticFile = () => {
  downloading.value = true;
  
  try {
    // 1. 静态文件路径（放在public目录下，路径从项目根目录开始）
    // 示例：public目录下的 templates/export-template.xlsx
    
    const filePath = 'temp.xlsx';
    
    // 2. 创建a标签触发下载
    const a = document.createElement('a');
    // 路径处理：开发环境直接使用相对路径，生产环境根据部署路径调整
    a.href = filePath;
    // 设置下载文件名（可选，不设置则使用原文件名）
    a.download = '预约报名签到用户信息模版.xlsx'; 
    document.body.appendChild(a);
    a.click();
    
    // 3. 清理
    document.body.removeChild(a);
    message.success('文件开始下载');
  } catch (error) {
    message.error('文件下载失败，请检查文件是否存在');
    console.error('静态文件下载错误：', error);
  } finally {
    downloading.value = false;
  }
};


const formData = reactive({
  goodAtList:good_at_list,
  areaList:area_list
})
const isShowAddModel=ref(false)

// 组件挂载时获取数据
onMounted(() => {
  //fetchTeacherOptions();
  let userInfo=JSON.parse(localStorage.getItem("userInfo"));
  if(userInfo.team_id == 'admin'){
    isShowAddModel.value=true;
  }
  fetchTeamOptions();

});

// 从接口获取选项数据
const fetchTeamOptions = async () => {
  //判断一下当前用户，如果是admin，那么需要查询全部的机构，如果不是admin，就取当前用户的机构信息即可
  let userInfo=JSON.parse(localStorage.getItem("userInfo"));
  if(userInfo.team_id != 'admin'){
    teamNameList.value=[{"team_id":userInfo.team_id,"team_name":userInfo.team_name}]
    saveFormState.team_id=userInfo.team_id
    saveFormState.team_name=userInfo.team_name
    fetchTeacherOptions();
  }else{
    let res=await $fetchTeamOptions();
    console.log(res)
    if(res.code=='success'){
        const data =res.data;
        teamNameList.value=res.data;
        saveFormState.team_id=data[0].team_id
        saveFormState.team_name=data[0].team_name
        console.log(saveFormState.team_id)
        fetchTeacherOptions();
    }
  }
};

// 从接口获取选项数据
const fetchTeacherOptions = async () => {
  const team_id= saveFormState.team_id;
  console.log("根据team_id查询老师："+team_id);
  if(!team_id){
      return ;
  }
  let res=await $fetchTeacherOptions(team_id);
  console.log(res)
  if(res.code=='success'){
      const data =res.data;
      teacherNameList.value=res.data;
      saveFormState.teacher_id=data[0].teacher_id
      saveFormState.teacher_name=data[0].teacher_name
  }

 
};
const formRef = ref();
const saveFormRef = ref();
const visible = ref(false);
const detailVisible=ref(false)
const imagesVisible=ref(false)
const showModel = () => {
  saveFormState.id=""
  
  visible.value = true;
}


//编辑按钮。根据id查询信息
const onEdit=async (data)=>{
 console.log(data)
 console.log("data.teacher_id="+data.teacher_id)
    //赋值，并显示
    saveFormState.id=data.id;
    saveFormState.kcid=data.kcid;
    saveFormState.kcname=data.kcname;//课程名称
    saveFormState.class_date=moment(data.class_date,'YYYY-MM-DD');//上课时间
    saveFormState.begin_time=moment(data.begin_time,'HH:mm:ss');//开始时间,moment(timeFromApi, 'HH:mm');
    saveFormState.end_time=moment(data.end_time,'HH:mm:ss');//结束时间
    saveFormState.people_size=data.people_size;//人数
    saveFormState.name=data.name;//预约联系人
    saveFormState.phone=data.phone;//联系人电话
    
    saveFormState.unit_name=data.unit_name;//单位名称
    saveFormState.teacher_name=data.teacher_name;//授课老师
    saveFormState.status=data.status;//课程状态
    saveFormState.address=data.address;//上课地址
    saveFormState.memo=data.memo;//修改备注
    saveFormState.team_id=data.team_id;
    saveFormState.team_name=data.team_name;
    saveFormState.teacher_id=data.teacher_id;
    visible.value = true;

}

/*
删除按钮
*/

const handleDelete=async (index,id)=>{
  console.log("删除的id="+id)
  let res=await $deleteUploadImage({"id":id})
  if(res.code=='success'){

    $getDakaImageList({"yyid":yyid.value}).then(res=>{ 
       if(res.code=='success'){
        tableData.imagesData=res.data
      }
    
    })
  }else{
    message.error(res.msg);
  }
}
/**
 * 课程图片
 */
const dakaInage=async (data)=>{
  yyid.value=data.id;
  let res=await $getDakaImageList({"yyid":data.id})
  if(res.code=='success'){

    tableData.imagesData=res.data
    imagesVisible.value=true
  }else{
    message.error(res.msg);
  }
}

/**
 * 拆分课程
 * @param data 课程信息
 */
const chaifenkecheng=async (data)=>{ 
  let res=await $chaifenkecheng({"yyid":data.id})
  if(res.code=='success'){
    loadData({pageNo:tableData.current,pageSize:tableData.pageSize});
  }else{
    message.error(res.msg);
  }

}

const tuisong=async (data)=>{
  let res=await $tuisong({"yyid":data.id})
  if(res.code=='success'){
    loadData({pageNo:tableData.current,pageSize:tableData.pageSize});
  }else{
    message.error(res.msg);
  }
}


/**
 * 查报名列表
 */
 const yyid = ref('');
const baomingList=async (data)=>{
  yyid.value=data.id;
  console.log(" 查报名列表的预约id="+data.id);
  let res=await $getBaomingList({"yyid":data.id})
  console.log(" 查报名列表")
  console.log(res)
  if(res.code=='success'){
    saveFormState2.kcname=data.kcname;//课程名称
    saveFormState2.class_date=data.class_date;//上课时间
    saveFormState2.begin_time=data.begin_time;//开始时间,moment(timeFromApi, 'HH:mm');
    saveFormState2.end_time=data.end_time;//结束时间
    saveFormState2.people_size=data.people_size;//人数
    saveFormState2.name=data.name;//预约联系人
    saveFormState2.phone=data.phone;//联系人电话
    saveFormState2.unit_name=data.unit_name;//单位名称
    saveFormState2.teacher_name=data.teacher_name;//授课老师
    saveFormState2.status=data.status;//课程状态
    saveFormState2.address=data.address;//上课地址
    saveFormState2.memo=data.memo;//修改备注
    saveFormState2.teacher_id=data.teacher_id;
    saveFormState2.team_id=data.team_id;
    saveFormState2.team_name=data.team_name;
    detailVisible.value=true
    
    tableData.currentDetailData=res.data
  }else{
    message.error(res.msg);
  }
  
}


//删除
let onDelete=async (id)=>{
  let res=await $deleteTeacher({id})
  // console.log(res)
  if(res.code=='success'){
      message.success(res.msg)
      //再次查询
      loadData({pageNo:tableData.current,pageSize:tableData.pageSize});
  }else{
    message.error(res.msg);
  }
}

const handleCancel=()=>{
  detailVisible.value=false;
}

const afterClose=()=>{
  visible.value=false;
}
const updateYuyue =async () => {
  console.log(saveFormState);
  saveFormRef.value.validateFields().then( async () => {
  //点击提交
  const class_date=saveFormState.class_date.format('YYYY-MM-DD');
  const begin_time=saveFormState.begin_time.format('HH:mm:ss');
  const end_time=saveFormState.end_time.format('HH:mm:ss');

  console.log("class_date:"+class_date)
  console.log("begin_time:"+begin_time)
  console.log("end_time:"+end_time)

  const params={};
  params.id=saveFormState.id;
  params.begin_time=begin_time;
  params.end_time=end_time;
  params.class_date=class_date;
  params.kcname=saveFormState.kcname;
  
  params.kcid=saveFormState.kcid;
  params.people_size=saveFormState.people_size;
  params.name=saveFormState.name;
  params.phone=saveFormState.phone;
  params.unit_name=saveFormState.unit_name;
  params.teacher_id=saveFormState.teacher_id;
  params.teacher_name=saveFormState.teacher_name;
  params.status=saveFormState.status;
  params.address=saveFormState.address;
  params.memo=saveFormState.memo;
  params.team_id=saveFormState.team_id;
  params.team_name=saveFormState.team_name;
  //如果老师的账号不为空，并且status状态是0，那要提醒一下，状态设置为1，待上课  
  if(params.teacher_id =="" || params.teacher_id==undefined || params.teacher_id==null || params.teacher_id=="null" ){
    params.status="0";
  }else{
    if(params.status =="0"){
      message.error("已经安排过老师，状态不能是[待安排老师]");return false;
    }
  }


  let res=await $updateYuyue(params);
  if(res.code=='success'){
    
   visible.value = false;
  
    //在调用一次列表查询的方法
   loadData({pageNo:tableData.current,pageSize:tableData.pageSize});
  }else{
    message.error(res.msg)
  }
  })
 
}

/**
 * 上传图片方法2：将图片转成base64的方式，当做成一个普通的字符串进行提交，使用统一封装的axios工具类request.js
 * @param param0 
 */
 const customUploadRequest =async ({ file, onSuccess, onError, onProgress }) => {
  console.log("自定义上传图片开始"+yyid.value);
  const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload =async () => {
      const base64String = reader.result;
        const param={
          "imgBase64Data":base64String,
          "fileName":file.name,
        }
      let res=await $uploadCert(param);
      saveExcelFormState.upload=[]
      if(res.code=='success'){
        onSuccess(res);  // 上传成功回调
        console.log(res)
        saveExcelFormState.upload=[]
        //上传一张，就保存一张
        $addUploadImage({"yyid":yyid.value,"imgurl":res.msg}).then(res=>{
        console.log(res)
        if(res.code=='success'){
        $getDakaImageList({"yyid":yyid.value}).then(res=>{
          if(res.code=='success'){
            tableData.imagesData=res.data
          }
        })
  
        }
      })
      }else{
        onError(res.msg);  // 上传失败回调
      }
    };

    reader.onerror = (error) => {
      onError(error);
    };
    
}

//上传excel
const customUploadExcelRequest=async ({ file, onSuccess, onError, onProgress }) => {
  console.log("自定义上传excel文件开始"+yyid.value);
  const formData = new FormData();
    formData.append('file', file);
    formData.append('type', "baoming");
    formData.append('yyid', yyid.value);  // 附加参数
    axios.post(baseUrl+'uploadExcel.do', formData, { //uploadExcel
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: progressEvent => {
        const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        onProgress({ percent });  // 更新进度条
      },
    })
    .then(response => {
      onSuccess(response.data);  // 上传成功回调
      saveExcelFormState.upload=[]
      //重新查询预约报名信息
      $getBaomingList({"yyid":yyid.value}).then(res=>{
        console.log(res)
        if(res.code=='success'){
          tableData.currentDetailData=res.data
        }
      })
      
    })
    .catch(error => {
      onError(error);  // 上传失败回调
    });
}

/**
 * 上传图片方法1：直接用multipart/form-data的方式进行上传文件,该方法直接使用了axios工具进行发送请求，未用到我们统一封装的axios工具类
 * @param param0 
 */
// const customUploadRequest1 =async ({ file, onSuccess, onError, onProgress }) => {
//   console.log("自定义上传图片开始");
//   const formData = new FormData();
//     formData.append('file', file);
//     formData.append('userId', 123);  // 附加参数
//     axios.post('/api/ajaxUpload.do', formData, {
//       headers: {
//         'Content-Type': 'multipart/form-data',
//       },
//       onUploadProgress: progressEvent => {
//         const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//         onProgress({ percent });  // 更新进度条
//       },
//     })
//     .then(response => {
//       onSuccess(response.data);  // 上传成功回调
//       loadData({pageNo:1,pageSize:10}); 
//     })
//     .catch(error => {
//       onError(error);  // 上传失败回调
//     });
// }


// 提交查询按钮
const onFinish = values => {
 loadData({pageNo:tableData.current,pageSize:tableData.pageSize});
};



//查询搜索框的数据绑定
const formState = reactive({
  kcname: '',
  class_date: '',
  class_date_begin:'',
  class_date_end:'',
  unit_name:"",
  status:"",
  teacher_name:"",
  phone:""
});


const statusMap = {
  "0": '待安排老师',
  "1": '待上课',
  "2": '已上课',
  "3": '已取消', // 可扩展更多状态
};



        
const detailColumns = [
{
    title: '序号',
    dataIndex: 'serialNumber',  // 虚拟字段，无需数据中存在
    key: 'serialNumber',
    width: "5%",  // 固定宽度，避免序号列过宽
    align: 'center',  // 居中显示
    // 自定义渲染：index 是当前行在循环中的索引
    customRender: ({ index }) => `${index + 1}`,
  },

{
    title: '报名时间',
    dataIndex: 'bmtime',
    width: '10%',
  },
  {
    title: '签到时间',
    dataIndex: 'qdtime',
    width: '10%',
  },
  {
    title: '姓名',
    dataIndex: 'name',
    width: '10%',
  },
  {
    title: '手机号',
    dataIndex: 'phone',
    width: '10%',
  },{
    title: '状态',
    dataIndex: 'status',
    width: '5%',
  }

];

const columns = [
{
    title: '预约编号',
    dataIndex: 'id',
    width: '5%',
  },
{
    title: '课程名称',
    dataIndex: 'kcname',
    width: '10%',
  },
  {
    title: '上课日期',
    dataIndex: 'class_date',
    width: '5%',
  },
  {
    title: '开始时间',
    dataIndex: 'begin_time',
    width: '5%',
  },
  {
    title: '结束时间',
    dataIndex: 'end_time',
    width: '5%',
  },
 
  {
    title: '机构名称',
    dataIndex: 'team_name',
    width: '5%',
  }, 
  {
    title: '授课老师',
    dataIndex: 'teacher_name',
    width: '5%',
  },
  {
    title: '人数',
    dataIndex: 'people_size',
    width: '5%',
  },
  {
    title: '预约联系人',
    dataIndex: 'name',
    width: '5%',
  },
  {
    title: '联系人电话',
    dataIndex: 'phone',
    width: '5%',
  },
  {
    title: '单位名称',
    dataIndex: 'unit_name',
    width: '5%',
  },
  
  {
    title: '课程状态',
    dataIndex: 'status',
    width: '5%',
    key:"status",
    customRender: ({ value }) => {
      
      // 若状态码不存在，显示“未知”
      return statusMap[value] || '未知';
    },
  },
  {
    title: '是否可推送',
    dataIndex: 'notice_flag',
    width: '5%',
    key:"notice_flag",
    customRender: ({ value }) => {
      console.log("notice_flag="+value)
      if(value=='1'){
         return "可推送"
      }else{
        return "不可推送"
      }
    },
  },
  {
    title: '上课地址',
    dataIndex: 'address',
    width: '10%',
  },
  
  {
    title: '操作',
    dataIndex: 'operation',
    width: '10%',
  },
];
let tableData =reactive({
        data:[],
        currentDetailData:[],
        imagesData:[],
        current:ref(1),
        total:ref(1),
        pageSize:10
});
//查询数据库
let loadData=async (params)=>{
  params.kcname=formState.kcname;
  params.class_date_begin=formState.class_date_begin;
  params.class_date_end=formState.class_date_end;
  params.unit_name=formState.unit_name;
  params.status=formState.status;
  params.teacher_name=formState.teacher_name;
  params.phone=formState.phone;
  let res=await $fetchReservationList(params);
  if(res.code=='success'){
      //取出数据data和总页数，分页使用
      console.log(res)
      let {total,pageSize,pageNo,list}=res.data
      tableData.data=list
      tableData.current=ref(pageNo)
      tableData.total=ref(total)
      tableData.pageSize=ref(pageSize)
  }
}
loadData({pageNo:1,pageSize:10}); 
let {data,current,total,pageSize,currentDetailData,imagesData} =toRefs(tableData)

const dataSource = ref(data);
const editableData = reactive({});
const edit = key => {
  console.log('key:'+(key-1))
  editableData[key] = cloneDeep(dataSource.value.filter(item => key === item.id)[0]);
};
const save =async (key) => {
  Object.assign(dataSource.value.filter(item => key === item.id)[0], editableData[key]);
  let res=await $updateYuyue(editableData[key]);
  delete editableData[key];
  if(res.code=='success'){
    message.success('保存成功')
    loadData({pageNo:tableData.current,pageSize:tableData.pageSize});
  }else{
    message.error('保存失败')
  }
};
const cancel = key => {
  delete editableData[key];
};


function onChange(page, pageSize) {
  let params= {pageNo:page,pageSize:pageSize}
  loadData(params);
}
function showSizeChange(current, size){
  let params= {pageNo:current,pageSize:size}
  loadData(params);
}
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
.pagination{
  margin-top: 40px;
  float: right;
}

.mySerachForm{
  margin-bottom: 20px;
  
  
}
.input{
    border-radius: 2px;
  }
  .onEdit{
    margin-left: 10px;
  }

  /* 图片容器：横向排列，间距控制 */
.image-container {
  display: flex;
  flex-wrap: wrap;  /* 超出换行 */
  gap: 8px;  /* 替代margin-right，更灵活 */
  padding: 10px 0;
}

/* 图片项：相对定位，用于删除按钮绝对定位 */
.image-item {
  position: relative;
  border-radius: 4px;  /* 加圆角优化样式 */
  overflow: hidden;    /* 避免图片拉伸超出圆角 */
  cursor: pointer;
  transition: box-shadow 0.3s;  /* 悬浮阴影过渡 */
}

/* 图片项悬浮效果 */
.image-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* 删除按钮：固定在图片右上角，悬浮显示 */
.delete-icon {
  position: absolute;
    top: 11px;
    right: 22px;
    font-size: 18px;
    color: rgba(255, 255, 255, 0.8);
    background-color: rgba(0, 0, 0, 0.4);
    width: 30px;
    height: 30px;
    border-radius: 100%;
    display: flex
;
    align-items: center;
    /* justify-content: center; */
    opacity: 0;
    transition: opacity 0.3s, background-color 0.3s;    position: absolute;
    top: 11px;
    right: 22px;
    font-size: 18px;
    color: rgba(255, 255, 255, 0.8);
    background-color: rgba(0, 0, 0, 0.4);
    width: 30px;
    height: 30px;
    border-radius: 100%;
    display: flex
;
    align-items: center;
    /* justify-content: center; */
    opacity: 0;
    transition: opacity 0.3s, background-color 0.3s;
}

/* 鼠标悬浮图片时显示删除按钮 */
.image-item:hover .delete-icon {
  opacity: 1;
}

/* 删除按钮悬浮效果 */
.delete-icon:hover {
  background-color: rgba(245, 245, 245, 0.9);
  color: #f5222d;  /* 红色强调删除操作 */
}
</style>